import { useCallback, useState } from "react";

const useTableFilters = () => {
  const [filters, setFilters] = useState<{
    keyword?: string;
    page?: number;
    limit?: number;
    sort?: string;
    order?: string;
    [key: string]: any;
  }>({
    page: 1,
    limit: 10,
    keyword: "",
    sort: "id",
    order: "desc",
  });

  // Update or add a filter key-value pair
  const updateFilter = useCallback((key: string, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }, []);

  // Reset all filters to initial state
  const resetFilters = useCallback(() => {
    setFilters({
      page: 1,
      limit: 10,
      keyword: "",
      sort: "id",
      order: "desc",
    });
  }, []);

  // console.log("Filters:", filters);

  return {
    filters,
    updateFilter,
    resetFilters,
  };
};

export default useTableFilters;
